import React from "react"

import {FormValueNotEmptyProps} from "../../../../popover/components/form/value-not-empty"
import FieldSelectEntityField from "../../select-entity-field"
import FieldProto from "../../../../../proto/field-proto"

type Props = FormValueNotEmptyProps & {
    field       : FieldSelectEntityField
}

// const debug = "FieldSelectEntityField_FormValueNotEmpty"
const debug = false

export default function FieldSelectEntityField_FormValueNotEmpty(props:Props) {

    debug && console.log(debug, 'render', props)

    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form no-wrap h-36", props.className,{
        'is-disabled': props.disabled
    })

    let selectedField: FieldProto | undefined = props.value

    const iconClasses = Classes('ui5-ico-15 m-r-8', selectedField?.icon)

    debug && console.log(debug, 'render selectedField', selectedField)

    return (
        <>
            <div className={valueClasses} onClick={props.onClick}>
                <div className={iconClasses}/>
                <span className="txt-truncate">{selectedField?.label}</span>
            </div>

            {props.children}
        </>
    )
}
